var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 434,
    height: 409,
    viewBox: "0 0 434 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2575_9129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.057 4.23121C207.057 6.6272 206.99 9.02318 206.854 11.4022C205.311 60.3925 186.983 105.152 157.413 140.14C150.886 148.024 143.646 155.416 135.931 162.162C98.8507 195.027 50.1899 214.942 -3.11661 215.027H-3.96436V0H206.939C207.074 1.4104 207.074 2.82081 207.074 4.23121H207.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434 183.709V409.017H418.91C390.884 406.978 364.349 399.45 340.459 387.402C323.606 378.957 308.025 368.251 294.105 355.728C268.129 332.362 247.97 302.591 236.237 268.877C236.203 268.758 236.152 268.656 236.118 268.537C230.082 251.409 227.251 233.311 227.251 215.129V0C250.632 0.135943 273.182 4.14625 294.105 11.4701C302.887 14.4269 311.382 18.0804 319.605 22.2436C364.129 44.6231 399.666 82.4151 419.249 128.67C426.489 145.985 431.542 164.422 434 183.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.394 198.205C196.121 198.205 190.865 198.409 185.66 198.834C166.772 200.176 148.58 204.119 131.438 210.236C97.5113 222.063 67.6027 242.539 44.2217 268.861C33.4044 280.96 23.9944 294.333 16.1951 308.692C2.3768 334.47 -6.40589 363.46 -8.44049 394.285C-8.86436 399.145 -9 404.073 -9 409.001H204.429V198.205H201.411H201.394Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2575_9129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 443,
    height: 409,
    fill: "white",
    transform: "translate(-9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmora);
export default __webpack_public_path__ + "static/media/amora.4c1405aaef97e4d1ef91aa122afa3c12.svg";
export { ForwardRef as ReactComponent };